class FroalaTextTransformPlugin {
  constructor() {
    this.registerShortcuts();
    this.registerPlugin();
    this.registerCommands();
    this.registerIcons();
  }

  registerIcons() {
    $.FE.DefineIcon('upcase', { NAME: 'format_size' });
    $.FE.DefineIcon('downcase', { NAME: 'text_fields' });
    $.FE.DefineIcon('titlecase', { NAME: 'title' });
  }

  registerShortcuts() {
    // Ctrl + U for UPCASE
    $.FE.RegisterShortcut($.FE.KEYCODE.TWO, "upcase", null, "2");
    // Ctrl + D for downcase
    $.FE.RegisterShortcut($.FE.KEYCODE.THREE, "downcase", null, "3");
    // Ctrl + ^ for Title Case
    $.FE.RegisterShortcut($.FE.KEYCODE.FOUR, "titlecase", null, "4");
  }

  registerPlugin() {
    $.FE.PLUGINS.text_transform = function(editor) {
      let transformType = 'upcase';
      let started = false, done = false;

      const downcase = (str) => str.trimRight().toLowerCase()
      const titlecase = (str) => str.trimRight().titleize()
      const upcase = (str) => str.trimRight().toUpperCase()
      const transforms = { upcase, downcase, titlecase }

      function transformNodeText(node, startOffset, substrLen) {
        const field = node.innerText ? 'innerText' : 'textContent';
        const content = node[field];
        if (content) {
          const toUpdate = content.substr(startOffset, substrLen);
          const updated = transforms[transformType](toUpdate)
          node[field] = node[field].replace(toUpdate, updated);
        }
      }

      function apply(requestedTransform) {
        const sel = editor.selection.get();
        if (sel.baseOffset == sel.extentOffset) {
          // Nothing selected, cancel.
          return;
        }
        transformType = requestedTransform;

        started = false;
        done = false;
        $.each(editor.selection.blocks(), (_, block) => {
          _processNode(block);
        });
      }

      function _processNode(block) {
        let childNodes = block.childNodes;

        if (childNodes.length > 0) {
          $.each(childNodes, (_, childNode) => {
            _processNode(childNode);
          })
        } else {
          _transformNode(block);
        }
      }

      function _transformNode(node) {
        let details = editor.selection.get(); // details about current selection

        // Traversing blocks of selection could include nodes before and after
        // the selected text! Enforce transforms from start block to end block
        // by flagging started and done.
        if (!started && !done) {
          // First node, transform from baseOffset to extentOffset if also
          // ending node, else end of node.
          if (node == details.baseNode) {
            let starting = details.baseOffset;
            let ending = details.extentNode == details.baseNode ? details.extentOffset : null;
            transformNodeText(node, details.baseOffset, ending);
            started = true;
          }
        } else if (started && !done) {
          // Final node, transform from 0 to extentOffset
          if (node == details.extentNode) {
            let starting = details.extentNode == details.baseNode ? details.baseOffset : 0;
            let ending = details.extentOFfset - starting;
            transformNodeText(node, starting, details.extentOffset - starting);
            done = true;

          } else {
            if (node == details.extentNode) {
              // Intermediate node, transform full text
              transformNodeText(node, 0);
            }
          }
        }
      }

      return { apply };
    }
  }

  registerCommands() {
    $.FE.RegisterCommand('upcase', {
      title: 'UPPERCASE',
      plugin: 'text_transform',
      callback: function() {
        this.selection.save();
        this.text_transform.apply('upcase');
        this.selection.restore();
      }
    });

    $.FE.RegisterCommand('downcase', {
      title: 'downcase',
      plugin: 'text_transform',
      callback: function() {
        this.selection.save();
        this.text_transform.apply('downcase');
        this.selection.restore();
      }
    });

    $.FE.RegisterCommand('titlecase', {
      title: 'Title Case',
      plugin: 'text_transform',
      callback: function() {
        this.selection.save();
        this.text_transform.apply('titlecase');
        this.selection.restore();
      }
    });
  }
}

export default FroalaTextTransformPlugin
